import parse from 'html-react-parser';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useKioskManager } from '../../../hooks/useKioskManager';
import { useLetsGo } from '../../../hooks/useLetsGo';
import ButtonStyled from '../button/Button';
import type { LocationDetails } from '../types';
import styles from './locationDetailsPopup.module.scss';

export type LocationDetailsPopupProps = {
  location: LocationDetails;
  closeButtonHandler: () => void;
};

export const LocationDetailsPopup: React.FC<LocationDetailsPopupProps> = ({
  location: { name, description, image, id },
  closeButtonHandler,
}) => {
  const { kiosk, kioskMode } = useKioskManager();

  const handleLetsGo = useLetsGo(id);
  const { t } = useTranslation('common');

  return (
    <div
      className={`${styles.popup} ${kiosk && kioskMode && styles[kiosk.model]}`}
      data-testid="locationDetailsPopup"
    >
      <img className={styles.image} alt={name} src={image} />

      <div
        className={`${styles.content} ${
          kiosk && kioskMode && styles[kiosk.model]
        }`}
      >
        <div className={styles.details}>
          <h1 className={styles.title}>{name}</h1>
          <p className={styles.description}>{parse(description)}</p>
        </div>
      </div>

      <div className={styles.actions}>
        <ButtonStyled onClick={handleLetsGo} className={styles.actionButton}>
          {t('labels.letsGo')}
        </ButtonStyled>

        <ButtonStyled
          onClick={closeButtonHandler}
          className={styles.actionButton}
          variant="outlined"
          ariaLabel="Close"
        >
          {t('labels.close')}
        </ButtonStyled>
      </div>
    </div>
  );
};
